// @flow

export const getIsIosDevice = (platform: string = navigator.platform) => {
  const iDevices = [
    'iPad Simulator',
    'iPhone Simulator',
    'iPod Simulator',
    'iPad',
    'iPhone',
    'iPod',
  ];

  if (!platform) {
    throw new Error('window.navigator.platform is undefined');
  }

  return iDevices.includes(platform);
};
